import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "").slice(0, 48);

export const FaqAccordion = ({ items }) => (
  <Accordion type="single" collapsible data-testid="faq-accordion">
    {items.map((f) => (
      <AccordionItem key={f.q} value={f.q} className="border-b border-neutral-200">
        <AccordionTrigger data-testid={`faq-trigger-${slug(f.q)}`} className="py-5 text-left font-display text-base font-bold tracking-tight sm:text-lg">
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="pb-5 pr-8 text-sm leading-relaxed text-neutral-600 sm:text-base">
          {f.a}
          {f.links?.length > 0 && (
            <span className="mt-3 flex flex-wrap gap-x-4 gap-y-1">
              {f.links.map((l) => (
                <Link key={l.to} to={l.to} className="text-sm font-bold text-brand-red underline-offset-4 hover:underline" data-testid={`faq-link-${slug(l.label)}`}>
                  {l.label} →
                </Link>
              ))}
            </span>
          )}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
